import * as React from "react";
import styled from "@mui/material/styles/styled";
import { CircularProgress } from "@mui/material";
import { NiceError } from "../error/niceError";

//region [[ Styles ]]

const LoadingContainerView = styled("div")(({ theme }) => ({
  height: "100%",
  position: "absolute",
  width: "100%",
  background: "white",
}));

const CenterSection = styled("div")(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const TopLevelLoadingContainer = ({
  error,
  message,
}: {
  error?: boolean;
  message?: string;
}) => {
  return (
    <LoadingContainerView>
      <CenterSection>
        {!error && <CircularProgress color="primary" />}
        {!!error && <NiceError error={error} message={message} />}
      </CenterSection>
    </LoadingContainerView>
  );
};
